export function attendancePages() {
    const viewport = {
        content: "width=device-width, initial-scale=1.0, user-scalable=no",
    };
    return {
        path: "/admin",
        name: "admin",
        component: () => import("@/views/admin/frame/home.vue"),
        meta: { title: "综合管理平台", viewport: viewport },
        children: [
            {
                path: "home",
                name: "home",
                component: () => import("@/views/admin/attendance/home/Home.vue"),
                meta: { title: "首页", viewport: viewport },
            },
            {
                path: "contacts",
                name: "contacts",
                component: () => import("@/views/admin/contacts/Home.vue"),
                meta: { title: "通讯录", viewport: viewport },
                children:[
                    {
                        path: "user",
                        name: "user",
                        component: () => import("@/views/admin/contacts/user/User.vue"),
                        meta: { title: "成员管理", viewport: viewport},
                    },
                    {
                        path: "userDetails",
                        name: "userDetails",
                        component: () => import("@/views/admin/contacts/user/UserDetails.vue"),
                        meta: { title: "详情", viewport: viewport },
                    },
                    {
                        path: "dept",
                        name: "dept",
                        component: () => import("@/views/admin/contacts/dept/Dept.vue"),
                        meta: { title: "部门管理", viewport: viewport},
                    },
                    {
                        path: "job",
                        name: "job",
                        component: () => import("@/views/admin/contacts/job/Job.vue"),
                        meta: { title: "岗位管理", viewport: viewport},
                    },
                    {
                        path: "role",
                        name: "role",
                        component: () => import("@/views/admin/contacts/role/Role.vue"),
                        meta: { title: "角色管理", viewport: viewport},
                    },
                    {
                        path: "hr",
                        name: "hr",
                        component: () => import("@/views/admin/contacts/hr/Home.vue"),
                        meta: { title: "人事管理", viewport: viewport },
                        children:[
                            {
                                path: "cooperationSchool",
                                name: "cooperationSchool",
                                component: () => import("@/views/admin/contacts/hr/cooperation/cooperationSchool/CooperationSchool.vue"),
                                meta: { title: "合作院校", viewport: viewport},
                            },
                        ]
                    }
                ]
            },
            {
                path: "pointCard",
                name: "pointCard",
                component: () => import("@/views/admin/contacts/hr/pointCard/PointCard.vue"),
                meta: { title: "积分商城", viewport: viewport },
                children:[
                    {
                        path: "product",
                        name: "product",
                        component: () => import("@/views/admin/contacts/hr/pointCard/product/Product.vue"),
                        meta: { title: "商品管理", viewport: viewport },
                    },
                    {
                        path: "setRule",
                        name: "setRule",
                        component: () => import("@/views/admin/contacts/hr/pointCard/setRule/SetRule.vue"),
                        meta: { title: "获取规则", viewport: viewport },
                    },
                    {
                        path: "totalPoints",
                        name: "totalPoints",
                        component: () => import("@/views/admin/contacts/hr/pointCard/totalPoints/TotalPoints.vue"),
                        meta: { title: "积分明细", viewport: viewport },
                    },
                    {
                        path: "exchangeDetail",
                        name: "exchangeDetail",
                        component: () => import("@/views/admin/contacts/hr/pointCard/exchangeDetail/ExchangeDetail.vue"),
                        meta: { title: "兑换明细", viewport: viewport },
                    },
                ]
            },
            {
                path: "attendance",
                name: "attendance",
                component: () => import("@/views/admin/contacts/Home.vue"),
                meta: { title: "考勤打卡", viewport: viewport },
                children:[
                    {
                        path: "scheduling",
                        name: "scheduling",
                        component: () => import("@/views/admin/attendance/scheduling/Scheduling.vue"),
                        meta: { title: "排班表", viewport: viewport },
                    },
                    {
                        path: "setScheduling",
                        name: "setScheduling",
                        component: () => import("@/views/admin/attendance/scheduling/SetScheduling.vue"),
                        meta: { title: "排班表", viewport: viewport },
                    },
                    {
                        path: "attendanceGroup",
                        name: "attendanceGroup",
                        component: () => import("@/views/admin/attendance/attendanceGroup/AttendanceGroup.vue"),
                        meta: { title: "考勤组", viewport: viewport },
                    },
                    {
                        path: "attendanceRules",
                        name: "attendanceRules",
                        component: () => import("@/views/admin/attendance/attendanceRules/Home.vue"),
                        meta: { title: "考勤规则", viewport: viewport },
                        children:[
                            {
                                path: "repairCard",
                                name: "repairCard",
                                component: () => import("@/views/admin/attendance/attendanceRules/repairCard/RepairCard.vue"),
                                meta: { title: "补卡规则", viewport: viewport },
                            },
                        ]
                    },
                    {
                        path: "statistics",
                        name: "statistics",
                        component: () => import("@/views/admin/attendance/statistics/Home.vue"),
                        meta: { title: "考勤统计", viewport: viewport },
                        children:[
                            {
                                path: "statement",
                                name: "statement",
                                component: () => import("@/views/admin/attendance/statistics/statement/Statement.vue"),
                                meta: { title: "报表管理", viewport: viewport },
                            },
                            {
                                path: "statementDetail",
                                name: "statementDetail",
                                component: () => import("@/views/admin/attendance/statistics/statement/StatementDetail.vue"),
                                meta: { title: "月度报表", viewport: viewport },
                            },
                            {
                                path: "clockInTime",
                                name: "clockInTime",
                                component: () => import("@/views/admin/attendance/statistics/statement/ClockInTime.vue"),
                                meta: { title: "打卡时间", viewport: viewport },
                            },
                            {
                                path: "dayStatistics",
                                name: "dayStatistics",
                                component: () => import("@/views/admin/attendance/statistics/statement/DayStatistics.vue"),
                                meta: { title: "每日统计", viewport: viewport },
                            },
                            {
                                path: "originalRecord",
                                name: "originalRecord",
                                component: () => import("@/views/admin/attendance/statistics/statement/OriginalRecord.vue"),
                                meta: { title: "每日统计", viewport: viewport },
                            },
                        ]
                    },
                    {
                        path: "classes",
                        name: "classes",
                        component: () => import("@/views/admin/attendance/classes/Classes.vue"),
                        meta: { title: "班次管理", viewport: viewport },
                    },
                    {
                        path: "holiday",
                        name: "holiday",
                        component: () => import("@/views/admin/attendance/holiday/Holiday.vue"),
                        meta: { title: "假期管理", viewport: viewport },
                        children:[
                            {
                                path: "holidayRule",
                                name: "holidayRule",
                                component: () => import("@/views/admin/attendance/holiday/holidayRule/HolidayRule.vue"),
                                meta: { title: "假期规则", viewport: viewport },
                            },
                            {
                                path: "holidayRemaining",
                                name: "holidayRemaining",
                                component: () => import("@/views/admin/attendance/holiday/holidayRemaining/HolidayRemaining.vue"),
                                meta: { title: "假期余额", viewport: viewport },
                            },
                        ]
                    },
                ]
            },
            {
                path: "performance",
                name: "performance",
                component: () => import("@/views/admin/performanceManagement/Home.vue"),
                meta: { title: "绩效管理", viewport: viewport },
                children:[
                    {
                        path: "performanceTemplate",
                        name: "performanceTemplate",
                        component: () => import("@/views/admin/performanceManagement/performanceTemplate/PerformanceTemplate.vue"),
                        meta: { title: "模板管理", viewport: viewport },
                    },
                    {
                        path: "createdPerformanceTemplate",
                        name: "createdPerformanceTemplate",
                        component: () => import("@/views/admin/performanceManagement/performanceTemplate/CreatedPerformanceTemplate.vue"),
                        meta: { title: "新增绩效模板", viewport: viewport },
                    },
                    {
                        path: "updatePerformanceTemplate",
                        name: "updatePerformanceTemplate",
                        component: () => import("@/views/admin/performanceManagement/performanceTemplate/UpdatePerformanceTemplate.vue"),
                        meta: { title: "编辑绩效模板", viewport: viewport },
                    },
                    {
                        path: "myPerformance",
                        name: "myPerformance",
                        component: () => import("@/views/admin/performanceManagement/performanceTemplate/MyPerformance.vue"),
                        meta: { title: "绩效表", viewport: viewport },
                    },
                    {
                        path: "performanceList",
                        name: "performanceList",
                        component: () => import("@/views/admin/performanceManagement/performanceTemplate/PerformanceList.vue"),
                        meta: { title: "绩效列表", viewport: viewport },
                    },
                    {
                        path: "selectPerformance",
                        name: "selectPerformance",
                        component: () => import("@/views/admin/performanceManagement/performanceTemplate/SelectPerformance.vue"),
                        meta: { title: "绩效详情", viewport: viewport },
                    },
                ]
            },
        ]
    };
}